import m from 'mithril';

export default {
  oncreate({ attrs, state }) {
    const KSummernoteDemo = (function init() {
      // Private functions
      const demos = function demos() {
        $(`#${state.id}`).summernote({
          height: 100,
          width: '100%',
          placeholder: 'Enter an instruction here',
          toolbar: [
            // [groupName, [list of button]]
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough']],
            ['para', ['ul', 'ol']],
          ],
          callbacks: {
            onChange: contents => attrs.oninput(contents),
          },
        });
      };

      return {
        init() {
          demos();
        },
      };
    }());

    // Initialization
    KSummernoteDemo.init();
  },
  onremove({ state }) {
    $(`#${state.id}`).summernote('destroy');
  },
  oninit({ state }) {
    // eslint-disable-next-line prefer-destructuring
    state.id = Math.random().toString().split('.')[1];
  },
  view({ state, attrs }) {
    return m(`#${state.id}`, m.trust(attrs.value));
  },
};
